import { Currency } from '@commercetools/frontend-sdk/lib/types/Currency';

interface LocalizationMapping {
  locale: string;
  localeName: string;
  currency: Currency;
  currencyCode: string;
  countryName: string;
  countryCode: string;
  countries: Array<string>;
}

const localizationMapper = {
  'en-us': {
    locale: 'en-US',
    localeName: 'English',
    currency: 'USD',
    currencyCode: '$',
    countryCode: 'US',
    countryName: 'United States',
    countries: ['US'],
  },
  'en-gb': {
    locale: 'en-GB',
    localeName: 'English',
    currency: 'GBP',
    currencyCode: '£',
    countryCode: 'GB',
    countryName: 'United Kingdom',
    countries: ['GB'],
  },
  'es-mx': {
    locale: 'es-MX',
    localeName: 'Spanish',
    currency: 'MXN',
    currencyCode: 'MXN',
    countryCode: 'MX',
    countryName: 'Mexico',
    countries: ['MX'],
  },
  'en-in': {
    locale: 'en-IN',
    localeName: 'English',
    currency: 'INR',
    currencyCode: '₹',
    countryCode: 'IN',
    countryName: 'India',
    countries: ['IN'],
  },
} as Record<string, LocalizationMapping>;

const locales = Object.keys(localizationMapper);
const defaultLocale = locales[0];

export const i18nConfig = { locales, defaultLocale };

export const getLocalizationInfo = (locale: string) => {
  if (!(locale in localizationMapper)) {
    console.warn(
      `Invalid locale ${locale} provided. Possible values are ${Object.keys(localizationMapper).join(', ')}`,
    );

    return localizationMapper[defaultLocale];
  }

  return localizationMapper[locale as keyof typeof localizationMapper];
};
